<template>
  <div
    class="form__input"
    :class="{'form__input--error': !!error }"
  >
    <select
      :id="id"
      :value="value"
      :disabled="disabled"
      :class="{ 'input': true, 'input__error': !!error, 'has-input': value !== '' }"
      :name="name"
      :required="required"
      @input="updateValue"
      @change="changeValue"
      @blur="$emit('blur')"
    >
      <option
        value=""
        disabled
      />
      <option
        v-for="option in options"
        :key="option[keyField]"
        :value="option[keyField]"
      >
        {{ option[displayField] }}
      </option>
    </select>

    <label
      v-if="label"
      :for="id"
      class="form__label"
    >
      {{ label }}
    </label>

    <p
      v-show="error"
      class="form__error"
    >
      {{ error }}
    </p>

    <font-awesome-icon
      :icon="['fas', 'sort']"
      class="icon alt"
    />
  </div>
</template>

<script>
export default {
  $_veeValidate: {
    name() {
      return this.label;
    },
    value() {
      return this.value;
    },
  },
  props: {
    value: {
      type: String,
      default: null,
    },
    keyField: {
      type: String,
      default: 'id',
    },
    displayField: {
      type: String,
      default: 'display_label',
    },
    options: {
      type: Array, // [{id,display_label}]
      required: true,
    },
    label: {
      type: String,
      default: 'Form Label',
    },
    name: {
      type: String,
      default: 'form-name',
    },
    id: {
      type: String,
      default: 'form-id',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
      required: false,
    },
    // eslint-disable-next-line vue/require-default-prop
    onChange: {
      type: Function,
    },
  },
  methods: {
    updateValue(e) {
      this.$emit('input', e.target.value);
    },
    changeValue(e) {
      this.$emit('change', 'input', e.target.value);

      if (this.onChange) {
        this.onChange();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  position: absolute;
  top: 22px;
  right: 15px;
  pointer-events: none;
}
</style>
